import React from 'react';
import { motion } from 'framer-motion';
import { galleryImages } from '../data/content';
export function ImageMarquee() {
  const loop = [...galleryImages, ...galleryImages, ...galleryImages, ...galleryImages];
  return <div className="relative -mx-5 overflow-hidden py-2 sm:mx-0" role="region" aria-label="Preview of the printable paper doll collection" data-id="element-107" data-mp="36x8if2z3q7o2">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 z-10 w-10 bg-gradient-to-r from-cream to-transparent sm:w-20" data-id="element-108" data-mp="3fgmjdhuh3kl" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 z-10 w-10 bg-gradient-to-l from-cream to-transparent sm:w-20" data-id="element-109" data-mp="8bxk0yaxouac" />

      <motion.ul className="flex w-max gap-4" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 30,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-110" data-mp="3ujx5e32ywqbj">
        {loop.map((image, index) => <li key={`${image}-${index}`} className="shrink-0" data-id="element-111" data-mp="2j48gh665lh83" data-mpi={index}>
            <img src={image} alt="" aria-hidden="true" className="h-44 w-auto rounded-2xl border-2 border-white bg-white object-cover shadow-card sm:h-56" loading="lazy" draggable={false} data-id="element-112" data-mp="3cpe29iesva09" />
          </li>)}
      </motion.ul>
    </div>;
}